
import {
    defineComponent, PropType, ref, watch,
} from 'vue';
import { OpeningHours } from '../types';
import { structureOpenDays, findNextOpenMoment } from '../services/openHours';

export default defineComponent({
    name: 'OpenHours',
    props: {
        data: {
            type: Array as PropType<OpeningHours[]>,
        },
    },
    setup(props) {
        const openDays = ref(undefined);
        const nextOpen = ref(undefined);

        function setOpenDays() {
            if (props.data) {
                openDays.value = structureOpenDays(props.data);
                setNextOpen();
            }
        }

        function setNextOpen() {
            if (openDays.value) {
                nextOpen.value = findNextOpenMoment(openDays.value);
                setTimeout(setNextOpen, 60 * 1000);
            }
        }

        watch(() => props.data, setOpenDays, { immediate: true });

        return {
            nextOpen,
        };
    },
});
